import { render, staticRenderFns } from "./AccountHolderExternalBankAccounts.vue?vue&type=template&id=053d3b46"
import script from "./AccountHolderExternalBankAccounts.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExternalBankAccounts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports